/* eslint-disable import/no-anonymous-default-export */
const FETCH_USER_GEOLOCATION = 'FETCH_USER_GEOLOCATION'
const UPDATE_USER_GEOLOCATION = 'UPDATE_USER_GEOLOCATION'

export default {
    FETCH_USER_GEOLOCATION,
    UPDATE_USER_GEOLOCATION
}